import { Component, OnInit, ViewChild } from '@angular/core';
import { MessageService } from 'primeng/api';
import { IAppointment } from 'src/app/shared/interfaces/appointment';
import { EAppointmentStatus } from 'src/app/shared/interfaces/appointmentStatus-enum';
import { EPaymentStatus } from 'src/app/shared/interfaces/paymentStatus-ennum';
import { IPayVisitInp } from 'src/app/shared/interfaces/payVisitInp';
import { EVisitType } from 'src/app/shared/interfaces/visitType-enum';
import { FakeDataService } from 'src/app/shared/mock/fake-data.service';
import { ModalComponent } from 'src/app/shared/modal/modal.component';
import { ShamsiDatePipe } from 'src/app/shared/pipes/shamsiDatePipe';
import { ApiService } from 'src/app/shared/services/api.service';
import { DateService } from 'src/app/shared/services/date.service';

@Component({
  selector: 'app-appointment-list',
  templateUrl: './appointment-list.component.html',
  styleUrl: './appointment-list.component.css'
})
export class AppointmentListComponent implements OnInit {

  appointmentsList: IAppointment[];
  visitType = EVisitType;
  appointmentStatus: EAppointmentStatus;
  paymentStatus= EPaymentStatus;
  visitStatus = EAppointmentStatus;
  visitId: any;
  tempVisit: IAppointment;
  todayDate: any;
  searchBody = {
    // id: 0,
    title: '',
    pageIndex: 1,
    pageSize: 10,
    type: null,
    status: null,
    paymentStatus: null,
    isAdmin: true
  }
  payVisitModel: IPayVisitInp = {
    visitId: 0,
    payByWallet: false,
    url: ''
  }

  first: number = 0 ;
  rows: number = 10;
  pageSize = 10;  
  currentpage = 1;
  collectionSize: number = 10;

  @ViewChild('modal') modal!: ModalComponent;
  @ViewChild('documents') documents!: ModalComponent;

  constructor(
    public apiService: ApiService,
    private messageService: MessageService,
    private dateService: DateService,
    private dateShamsi: ShamsiDatePipe,
    private fakeData: FakeDataService
  ){}

  ngOnInit(): void {
    this.todayDate = this.dateService.getTodayGregorianDateTime();

    this.getAppointmentList(1);
  }

  convertUTCMinutesToLocal(utcMinutes: number): number | any {
    // Get the current date (ignoring time) in UTC
    const utcDate = new Date();
    utcDate.setUTCHours(0, 0, 0, 0); // Reset to 00:00 UTC
  
    // Add UTC minutes to the date
    utcDate.setUTCMinutes(utcMinutes);
  
    // Convert to local time
    const localHours = utcDate.getHours(); // Local hours
    const localMinutes = utcDate.getMinutes(); // Local minutes
  
    // Convert local time to total minutes from 00:00 local time
    return this.calculateTime(localHours * 60 + localMinutes);
  }

  // This function checks if the visit time passed, the buttons will become disabled 
  isActiveVisitLink(date, startVisit): boolean {

    // const now = new Date();
    // const currentMinutes = now.getHours() * 60 + now.getMinutes();

    // if(this.todayDate.slice(0,10) > date.slice(0,10) && currentMinutes > startVisit) {      
    //   return true;
    // }

    const now = new Date();
    const currentMinutes = now.getHours() * 60 + now.getMinutes();

    // Convert UTC startVisit to local minutes
    const utcDate = new Date(date);
    utcDate.setUTCHours(0, 0, 0, 0); // Reset to 00:00 UTC
    utcDate.setUTCMinutes(startVisit);

    // Get local time from UTC date
    const localHours = utcDate.getHours();
    const localMinutes = utcDate.getMinutes();
    const startVisitLocal = localHours * 60 + localMinutes;

    // Check if the visit time has passed
    if (this.todayDate.slice(0, 10) > date.slice(0, 10) || currentMinutes > startVisitLocal) {
        return true;
    }

    return false;
    
  }

  getAppointmentList(page) {
    // this.fakeData.getAppointments().subscribe((res: IAppointment[]) => {
    //   this.appointmentsList = res;
    // })

    this.searchBody = {
      // id: 0,
      title: this.searchBody.title,
      pageIndex: page,
      pageSize: this.pageSize,
      type: Number(this.searchBody.type),
      status: Number(this.searchBody.status),
      paymentStatus: Number(this.searchBody.paymentStatus),
      isAdmin: false
    }

    this.apiService.apiCall('post', '/api/User/GetAllVisit', this.searchBody).subscribe((res: any) => {
      console.log(res);
      
      this.appointmentsList = res.body.model;
      this.collectionSize = res.body.collectionSize;
    })
  }

  calculateTime(time) {
    const hours = Math.floor(time / 60);
    const minutes = time % 60;
    // Format the time as HH:mm
    const timeString = `${String(hours).padStart(2, '0')}:${String(minutes).padStart(2, '0')}`;
    return timeString
  }

  payVisit(id) {    
    this.payVisitModel = {
      visitId: id,
      payByWallet: false,
      url: window.location.origin+'/user/appointment'
    }
    this.apiService.apiCall('post', '/api/PatientsVisitActive/PayVisit', this.payVisitModel).subscribe((res: any) => {
      console.log(res);
      
      if (res.body.isSuccess == true) {
        // if (res.body.model.zarinUrl == null || this.isEnough) {
        //   this.router.navigate(['/visit-link/' + this.viditId])
        // } else {
          window.location.href = res.body.model.zarinUrl;
        // }
      } else {
        this.messageService.add({severity: 'error', summary:  'خطا', detail: res.body.message});
      }
    })
  }

  visitCancel() {
    this.apiService.apiCall('post', '/api/User/CancelVisit/' + this.visitId).subscribe((res: any) => {
      console.log(res);
      
      if (res.body.isSuccess == true) {
        this.modal.close();
        
        this.messageService.add({severity: 'success', summary: 'موفق', detail: 'ویزیت شما با موفقیت لغو شد.' });
      } else {
        this.messageService.add({severity: 'error', summary: 'خطا', detail: res.body.message });
      }
    })
  }

  getFileExtension(fileName: string): string | null {
    return fileName?.includes('.') ? fileName?.split('.').pop() : null;
  }

}
